import { Request } from "@konv/http";
import { UserStorage } from "../shared/tools/UserStorage";

export class OnboardingAPI {
  static async request({
    endpoint = "/",
    method = "GET",
    headers,
    query,
    data,
  }) {
    return await Request.request({
      endpoint: endpoint,
      method: method,
      headers: headers,
      service: "onboarding",
      ignoreVersion: true,
      params: query,
      data: data,
    });
  }

  static async requestAuthenticated({
    endpoint = "/",
    method = "GET",
    query,
    data,
  }) {
    return await OnboardingAPI.request({
      endpoint,
      headers: { Authorization: "Bearer " + UserStorage.getAccessToken() },
      method,
      query,
      data,
    });
  }

  static async getBrands() {
    return (
      await OnboardingAPI.requestAuthenticated({
        endpoint: `/brands`,
        method: "GET",
      })
    ).getData([]);
  }

  static async putBrands(payload) {
    return await OnboardingAPI.requestAuthenticated({
      endpoint: `/brands`,
      method: "PUT",
      data: payload || {},
    });
  }

  static async getUnits() {
    return (
      await OnboardingAPI.requestAuthenticated({
        endpoint: `/units`,
        method: "GET",
      })
    ).getData([]);
  }

  static async putUnits(payload) {
    return await OnboardingAPI.requestAuthenticated({
      endpoint: `/units`,
      method: "PUT",
      data: payload || {},
    });
  }

  static async getMappings() {
    return (
      await OnboardingAPI.requestAuthenticated({
        endpoint: `/switches`,
        method: "GET",
      })
    ).getData([]);
  }

  static async putMappings(payload) {
    return await OnboardingAPI.requestAuthenticated({
      endpoint: `/switches`,
      method: "PUT",
      data: payload || {},
    });
  }

  static async putStatus(endpoint) {
    return await OnboardingAPI.requestAuthenticated({
      method: "PUT",
      endpoint,
    });
  }
}
